/* ------------------------------------------ Start ------------------------------ */
var clock;

/* ------------------------------------------ Ready and Init ------------------------------ */

$(document).ready(function () {
  startClock();
});

// inits clock
function startClock() {
  // running-clock is the class for all clocks dynamically keeping time (so far just the left nav,edit shift modal, and kiosk clock in/out page)
  if ($(".running-clock .display .hours").length > 0) {
    clock = new Clock();
    clock.start();
  }
}

/* ------------------------------------------ Clock Object ------------------------------ */
// info: internal time in military hours
var clockVisibilityListenerBound = false;

var Clock = function Clock() {
  var h,
    m,
    s,
    secInt = 0;

  // sets display for sync
  $("#clock .display").css("display", "none"); // #clock is the clock in the left nav others will duplicate

  /* ---------------- (clock object) inner functions ------------- */
  this.start = function () {
    var o = new Object();
    o = getDisplay();
    h = o.H;
    m = o.M;
    s = o.S;
    o.HUp = true;
    o.MUp = true;
    putDisplay(o);

    // update
    secInt = setInterval(advance, 1000);

    if (!clockVisibilityListenerBound) {
      clockVisibilityListenerBound = true;
      document.addEventListener("visibilitychange", function () {
        if (!$("#clock .display .hours").length) {
          return;
        }
        if (document.hidden) {
          if (secInt) {
            clearInterval(secInt);
            secInt = 0;
          }
        } else if (!secInt) {
          secInt = setInterval(advance, 1000);
          if (typeof GetAjaxCurrentLocalTime === "function") {
            GetAjaxCurrentLocalTime();
          }
        }
      });
    }
    if (typeof document !== "undefined" && document.hidden && secInt) {
      clearInterval(secInt);
      secInt = 0;
    }
  };

  this.update = function (o) {
    if (!isNaN(parseInt(o.H, 10))) h = parseInt(o.H);
    if (!isNaN(parseInt(o.M, 10))) m = parseInt(o.M);
    if (!isNaN(parseInt(o.S, 10))) s = parseInt(o.S);
    showSync(o);
  };

  /* ---------------- (clock object) sync utilities ------------- */
  // sync function
  // sets clock hide during sync
  function hideSync() {
    $("#clock .loading").fadeOut(100);
    $("#clock .display").fadeIn(100);
  }

  // sync function
  // updates display from update()
  // calls putsDisplay()
  function showSync(o) {
    if (typeof o.LOGOUT != "undefined") $("#clock").find(".loading, .display").hide();
    else {
      $("#clock .loading").fadeIn(100);
      $("#clock .display").fadeOut(100, function () {
        o.HUp = true;
        o.MUp = true;
        putDisplay(o);
        window.setTimeout(hideSync, 250);
      });
    }
  }

  // updates time
  // calls putDisplay()
  function advance() {
    var mup = false;
    var hup = false;
    s++;
    if (s > 59) {
      s -= 60;
      m += 1;
      mup = true;
    }
    if (m > 59) {
      m -= 60;
      h += 1;
      hup = true;
    }
    if (h > 23) {
      h -= 24;
    }

    var hd = parseInt(h);
    var md = parseInt(m);
    var sd = parseInt(s);

    if (md < 10) {
      md = formatAsTwoDigits(md);
    }
    if (sd < 10) {
      sd = formatAsTwoDigits(sd);
    }

    putDisplay({
      H: hd,
      M: md,
      S: sd,
      HUp: hup,
      MUp: mup,
    });
  }

  /* ---------------- (clock object) display functionality ------------- */

  // creates display
  // returns clock object
  function getDisplay() {
    var o = new Object();
    var $clock = $("#clock");

    var ht = parseInt($clock.find("div.hours").html().replace("&nbsp;", ""), 10);
    var mt = parseInt($clock.find("div.minutes").html(), 10);
    var st = parseInt($clock.find("div.seconds").html(), 10);

    o.H = ht;
    o.M = mt;
    o.S = st;

    return o;
  }

  // sets display (am-pm)
  function putDisplay(o) {
    var ampm = "AM";

    if (typeof o.HUp == "undefined") o.HUp = false;
    if (typeof o.MUp == "undefined" || isNaN(o.MUp)) o.MUp = false;
    if (o.H > 11) {
      o.H -= 12;
      ampm = "PM";
    }

    if (o.H == 0) {
      o.H = 12;
    }

    if (o.HUp) {
      $(".running-clock").find(".hours").html(o.H).end().find(".ampm").html(ampm);
      $(".running-clock")
        .find("div.ampm")
        .css({
          lineHeight: ampm == "AM" ? "16px" : "23px",
        });
    }

    if (o.MUp) {
      $(".running-clock").find(".minutes").html(formatAsTwoDigits(o.M));
    }
    $(".running-clock").find(".seconds").html(formatAsTwoDigits(o.S));
  }
};

/* ------------------------------------------ Utilities ------------------------------ */

/**
 *	Update the clock when called from ajaxIntervalUpdate()
 *	@param {Object} o - in the form of {S: "27", TZ: "EDT", UserID: "3", H: "14", M: "24"}
 *
 */
function updateClock(o) {
  // update timezone here if it is defined, no need to update every second!
  let clockData = $(".clock-container").data(); // set in Clock.cfm
  let showTimezone = clockData.showTimezone.toString() === "true";
  if (showTimezone && o.TZ) {
    $(".timezone").html(o.TZ);
  }
  // ensure clock has loaded
  if (typeof clock == "undefined" || clock == null) {
    startClock();
  }

  // updated only (if) needed
  if (updateClockOkay()) {
    clock.update(o);
  }

  // sets UTC time
  g.lastUTCms = getUTC_ms();
}

// checks clock update timeframe
function updateClockOkay() {
  var ms = 3 * 60 * 1000; // 3mins: 3mins * 60seconds * 1000ms = 180000ms
  ms -= 30 * 1000; // take it 30 seconds back to ensure updates during the 3 minute time interval
  return getUTC_ms() - g.lastUTCms > ms;
}

// checks UTC time
function getUTC_ms() {
  var d = new Date();
  return d.getTime();
}

/* ------------------------------------------ Clock Submit Functionality ------------------------------ */

/* ------------------------------------------ Functions ------------------------------ */

// function computeDuration, returns a time string in decimal format with hrs added - (ie. "7.54 hrs")
// takes values for dateStart/dateEnd in format xx-xx-xxxx
// takes values for hourStart,hourEnd,minuteStart,minuteEnd
// takes values for ampmStart,ampmEnd as "AM" or "PM"
// optional returnRaw (default false): when true, returns decimal hours only
// optional logToConsole (default false): when true, logs inputs and results to the console
function computeDuration(
  dateStart,
  hourStart,
  minuteStart,
  ampmStart,
  dateEnd,
  hourEnd,
  minuteEnd,
  ampmEnd,
  returnRaw,
  logToConsole,
) {
  var days;
  var hours;
  var minutes;
  hourStart = parseInt(hourStart, 10);
  hourEnd = parseInt(hourEnd, 10);
  minuteStart = parseInt(minuteStart, 10);
  minuteEnd = parseInt(minuteEnd, 10);
  ampmStart = ampmStart + "";
  ampmEnd = ampmEnd + "";
  if (typeof returnRaw == "undefined") returnRaw = false;
  if (typeof logToConsole == "undefined") logToConsole = false;

  // Align with TimeFunctions.Convert12HourTo24Hour + form conventions:
  // - hour > 12: already 24h (non-standard grid / mismatched meridian fix path)
  // - hour === 12: TsTimePicker v2 submits 12 for both midnight and noon; use meridian
  // - hour 0–11: classic 12h (v1 hidden 0–11, or v2 1–11 face)
  function to24Hour(hour, ampm) {
    ampm = String(ampm).toUpperCase();
    if (hour > 12) {
      return hour;
    }
    if (hour === 12) {
      return ampm === "PM" ? 12 : 0;
    }
    if (ampm === "PM") {
      return hour + 12;
    }
    return hour;
  }
  hourStart = to24Hour(hourStart, ampmStart);
  hourEnd = to24Hour(hourEnd, ampmEnd);

  var tempStartDate = dateStart.split("-");
  tempStartMonth = parseInt(tempStartDate[0], 10);
  tempStartDay = parseInt(tempStartDate[1], 10);
  tempStartYear = parseInt(tempStartDate[2], 10);

  var tempEndDate = dateEnd.split("-");
  tempEndMonth = parseInt(tempEndDate[0], 10);
  tempEndDay = parseInt(tempEndDate[1], 10);
  tempEndYear = parseInt(tempEndDate[2], 10);

  // NOTE: Months in javascript are 0-11!!! (thus the -1)
  startDateConverted = Date.UTC(tempStartYear, tempStartMonth - 1, tempStartDay, hourStart, minuteStart, 0);
  EndDateConverted = Date.UTC(tempEndYear, tempEndMonth - 1, tempEndDay, hourEnd, minuteEnd, 0);

  daysDifferenceInMiliseconds = EndDateConverted - startDateConverted;
  minutesDifference = daysDifferenceInMiliseconds / 60000;
  rawHours = Math.round((minutesDifference / 60) * 100) / 100;

  var x = daysDifferenceInMiliseconds / 1000;
  if (x < 0) {
    minutes = Math.ceil((x / 60) % 60);
    hours = Math.ceil((x / 60 / 60) % 24);
    days = Math.ceil(x / 60 / 60 / 24);
  } else {
    minutes = Math.floor((x / 60) % 60);
    hours = Math.floor((x / 60 / 60) % 24);
    days = Math.floor(x / 60 / 60 / 24);
  }

  var s = rawHours + plural(" hr", rawHours);
  if (rawHours != 0) {
    var detailParts = [];
    if (days != 0) {
      detailParts.push(days + plural(" day", days));
    }
    if (hours != 0) {
      detailParts.push(hours + plural(" hr", hours));
    }
    if (minutes != 0) {
      detailParts.push(minutes + plural(" min", minutes));
    }
    s += " (" + detailParts.join(" ") + ")";
  }

  if (logToConsole) {
    console.groupCollapsed("computeDuration");
    console.log("arguments", arguments);
    console.log("dateStart", dateStart);
    console.log("hourStart", hourStart);
    console.log("minuteStart", minuteStart);
    console.log("ampmStart", ampmStart);
    console.log("dateEnd", dateEnd);
    console.log("hourEnd", hourEnd);
    console.log("minuteEnd", minuteEnd);
    console.log("ampmEnd", ampmEnd);
    console.log("returnRaw", returnRaw);
    console.log("rawHours", rawHours);
    console.log("s", s);
    console.groupEnd();
  }

  if (returnRaw) return rawHours;
  else return s;
}

// called from openClockInMiniForm()
function closeClockInOutMiniForm() {
  $("div.ClockInOutMiniForm:visible").hide().html("");
}
// Old school Clock in/out form fired from the Status column on the Dashboard
function openClockInOutMiniForm(userid, action, returnto, continueto) {
  var action = action.toLowerCase();
  action = action === "in" || action === "out" ? action : "in";
  var url = g.baseApiUrl + "/clock/" + action + "/form/" + userid;
  var $e = $("#ClockInOutMiniForm" + userid);
  closeClockInOutMiniForm();
  $e.html('<div class="clockInOutContainer"><div class="ajaxLoader ajaxLoaderIcon"></div></div>').show();
  $.ajax({
    type: "GET",
    url: url,
    cache: false,
    dataType: "html",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    data: {
      ReturnTo: returnto,
      ContinueTo: continueto,
    },
    success: function (data) {
      $e.html(JSON.parse(data));
      // position the old jq modal based on the same line as the user
      if (window.innerWidth > 576) {
        // larger than $phoneBreakpoint in scss
        $("#clockInOutFloatingDiv").position({
          my: "center top-56",
          at: "center middle",
          of: $e.closest("td"),
          collision: "fit",
        });
        $("#clockInOutFloatingDivArrow")
          .position({
            my: "left middle",
            at: "left middle",
            of: $e.closest("td"),
            within: $e.closest("td"),
            collision: "none",
          })
          .css({
            left: parseInt($("#clockInOutFloatingDiv").css("left"), 10) - 22 + "px",
          });
      } else {
        // position top, center for phones
        $("#clockInOutFloatingDivArrow").hide();
        $("#clockInOutFloatingDiv").position({
          my: "top+70", // "center top",
          at: "center", //  "center top",
          of: $("#header"),
        });
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      processAjaxError(jqXHR, textStatus, errorThrown, "_Clock::openClockInOutMiniForm()", true);
    },
  });
}
